import { Award, Lock } from "lucide-react";

const fmt = (iso) => new Date(`${iso}T12:00:00`).toLocaleDateString(undefined, { month: "short", day: "numeric" });

const tones = {
  3: "from-amber-300 to-orange-400 text-amber-950",
  7: "from-emerald-300 to-teal-500 text-emerald-950",
  30: "from-indigo-300 to-violet-500 text-indigo-950",
};

export const StreakBadges = ({ badges, compact = false }) => {
  if (!badges?.length) return null;
  return (
    <div className={`grid grid-cols-3 gap-3 ${compact ? "" : "sm:gap-4"}`} data-testid="streak-badges">
      {badges.map((b) => (
        <div
          key={b.days}
          className={`relative rounded-2xl border p-3 sm:p-4 flex flex-col items-center text-center gap-2 transition-transform duration-300 ${b.earned ? "border-transparent bg-gradient-to-br shadow-sm hover:-translate-y-0.5 " + tones[b.days] : "border-dashed border-slate-200 bg-slate-50 text-slate-400"}`}
          title={b.description}
          data-testid={`streak-badge-${b.days}${b.earned ? "-earned" : "-locked"}`}
        >
          <span className={`w-10 h-10 rounded-full grid place-items-center ${b.earned ? "bg-white/60" : "bg-white"}`}>
            {b.earned ? <Award className="w-5 h-5" /> : <Lock className="w-4 h-4" />}
          </span>
          <p className="font-display font-extrabold text-lg leading-none">{b.days}<span className="text-xs font-semibold"> days</span></p>
          {!compact && <p className="text-xs font-semibold">{b.title}</p>}
          <p className="text-[11px] leading-tight">
            {b.earned ? `Earned ${b.earned_on ? fmt(b.earned_on) : ""}` : `${b.progress}/${b.days} in your current streak`}
          </p>
        </div>
      ))}
    </div>
  );
};
